module.exports = __webpack_public_path__ + "static/media/clockBS.8021d0c9.svg";